<template>
  <div class="flex grow flex-col">
    <div class="flex grow flex-col overflow-hidden">
      <AnimatePresence>
        <Motion
          v-if="showMobileSidebar"
          key="mobile-sidebar"
          class="fixed inset-0 z-50 flex w-full flex-shrink-0 flex-col lg:hidden"
          :initial="{ x: '-100%' }"
          :animate="{ x: 0 }"
          :exit="{ x: '-100%' }"
          :transition="{ duration: 0.15, ease: 'easeOut' }"
        >
          <MobileSidebar />
        </Motion>
      </AnimatePresence>
      <div class="fixed inset-0 flex grow flex-col transition-spacing">
        <AppHeader>
          <slot name="header-content" />
        </AppHeader>
        <div
          class="flex grow flex-col overflow-y-auto"
          data-scroll-container
        >
          <div class="flex grow flex-col">
            <slot />
          </div>
          <div
            v-if="!hideFooter"
            class="shrink-0"
          >
            <AppFooter />
          </div>
        </div>
      </div>
    </div>
    <ModalContainer />
    <CookieConsentBanner />
  </div>
</template>

<script setup lang="ts">
const { showMobileSidebar } = useLayoutState()

defineProps<{
  hideFooter?: boolean
}>()
</script>
